import { apiRequest } from './api';

export interface LaneListResponse {
  lanes: unknown;
}

export interface LaneStat {
  name: string;
  track_count: number;
}

export interface LaneStatsResponse {
  lanes: LaneStat[];
}

export const FALLBACK_LANES = [
  'Boom Bap 254',
  'Club Banger',
  'Gengetone',
  'New Nairobi',
  'Sheng Wave',
  'Trap 254'
];

let cachedLanes: string[] | null = null;
let inFlight: Promise<string[]> | null = null;

function normalizeLanes(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  const seen = new Set<string>();
  const lanes: string[] = [];

  for (const entry of raw) {
    const lane = String(entry ?? '').trim();
    if (!lane) continue;
    const key = lane.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    lanes.push(lane);
  }

  return lanes;
}

export function getCachedLanes(): string[] | null {
  return cachedLanes ? [...cachedLanes] : null;
}

export function invalidateLaneOptionsCache(): void {
  cachedLanes = null;
  inFlight = null;
}

export async function fetchLaneOptions(options?: { force?: boolean }): Promise<string[]> {
  if (!options?.force && cachedLanes) {
    return cachedLanes;
  }
  if (!options?.force && inFlight) {
    return inFlight;
  }

  inFlight = apiRequest<LaneListResponse>('/lanes')
    .then((data) => {
      const normalized = normalizeLanes((data as LaneListResponse).lanes);
      cachedLanes = normalized.length ? normalized : FALLBACK_LANES;
      inFlight = null;
      return cachedLanes;
    })
    .catch((error) => {
      inFlight = null;
      throw error;
    });

  return inFlight;
}

export async function fetchLaneStats(): Promise<LaneStat[]> {
  const response = await apiRequest<LaneStatsResponse>('/lanes/stats');
  return (response.lanes ?? []).map((lane) => ({
    name: lane.name,
    track_count: Number(lane.track_count) || 0,
  }));
}
